import React, { useState } from "react"
import styled, { keyframes } from "styled-components"
import { Container, H1 } from "../general/GeneralStyles"

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 50px;
`

const Title = styled.h2`
  text-align: center;
  margin-bottom: 60px;
  color: #182f4a;

  @media (max-width: 570px) {
    margin-bottom: 20px;
  }
`

const WorkplacesContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  max-width: 700px;
  width: 95%;

  @media (max-width: 570px) {
    flex-direction: column;
    align-items: center;
  }
`

const Workplaces = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 570px) {
    flex-direction: row;
    margin-bottom: 6px;
  }
  
`

const Job = styled.div`
  text-align: left;
  padding: 10px;
  border-left: solid 3px #182f4a;
  cursor: pointer;
  transition: all .3s ease;
  color: #182f4a;

  &.active {
    border-left: solid 3px #0af;
  }

  @media (max-width: 570px) {
    border-left: unset;
    border-top: solid 3px #182f4a;

    &.active {
        border-left: unset;
        border-top: solid 3px #0af;
    }
  }
`

const SelectedJobContainer = styled.div`
  margin-left: 30px;

  h3 {
    color: #182f4a;
    margin: 0px;
  }

  span {
      color: #182f4a;
  }

  h3 span {
      color: #0af;
      display: inline-block;
  }

  ul {
      margin-top: 16px;
      list-style-type: circle;
  }

  li {
    color: #182f4a
  }
`

const Tabs = [
  {
    name: "theLinc",
    title: "Principal Software Engineer",
    dates: "August 2019 - Present",
    items: [
      `In charge of Development practices at theLinc with Vue.js, Vuex, Laravel.`,
      `Created in-app messenger with websockets integration (Pusher).
        Main Developer for features such as: Version Restoration, Blockly formula integration,
        and inline editing Smart Table.`,
      `Created and mantained e2e tests using Cypress and implemented various Vue libraries (vue-draggable, vue2-dropzone, Blockly)
        and standard SPA practices (Vue router, Vuex State management) 
        that were absent when I started.`,
    ],
  },
  {
    name: "Three21",
    title: "Lead Developer",
    dates: "April 2018 - August 2019",
    items: [
      `In charge of leading Software Development efforts for various SaaS apps made with React and Laravel
        and creating sites for clients using WordPress.`,
      `Introduced team to Storybook and Unit and Integration 
        Testing with react-testing-library and Jest.`,
      `Aided in the mentoring of Junior Developers and in the quoting process for websites and SaaS apps.`,
    ],
  },
  {
    name: "MarketSmart",
    title: "FrontEnd Developer",
    dates: "October 2017 - April 2018",
    items: [
      `Solo developer for Custom Theme WordPress Development shop.`,
      `In charge of fixing Backend (PHP) and Front-End (JS-CSS-HTML) bugs 
      In charge of implementing new features for our client sites such as WooCommerce Implementation and API integrations.`,
    ],
  },
]

const Experience = props => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <Wrapper>
      <Title>Experience</Title>
      <WorkplacesContainer>
        <Workplaces>
          {Tabs.map((tab, index) => (
            <Job
              onClick={() => setActiveTab(index)}
              className={activeTab == index ? "active" : null}
            >
              {tab.name}
            </Job>
          ))}
        </Workplaces>
        <SelectedJobContainer>
          <h3>
            {Tabs[activeTab].title}
            <span> @{Tabs[activeTab].name}</span>
          </h3>
          <span>{Tabs[activeTab].dates}</span>
          <ul>
            {Tabs[activeTab].items.map((item, index) => (
                <li>
                {item}
                </li>
            ))}
          </ul>
        </SelectedJobContainer>
      </WorkplacesContainer>
    </Wrapper>
  )
}

export default Experience
